import { render } from "./ProfileIndex.vue?vue&type=template&id=f1d0ef9c"
import script from "./ProfileIndex.vue?vue&type=script&lang=js"
export * from "./ProfileIndex.vue?vue&type=script&lang=js"

import exportComponent from "/private/tmp/claude-501/-Users-andrei-Desktop-EO-LARAVEL/7545e444-cd9b-404a-a970-150d45c9bb29/scratchpad/wt-csf-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__